
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
import demo from './demo/theme.twig';
import alternateDemo from './demo/theme-alternate.twig';
const demoStory = (args) => demo(args);


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Design/Themes" mdxType="Meta" />
    <h1>{`Themes`}</h1>
    <p>{`Themes may be applied to a containing element to change that content's appearance. Theme classes are always prefixed by `}<inlineCode parentName="p">{`t-`}</inlineCode>{`, for example `}<inlineCode parentName="p">{`t-dark`}</inlineCode>{`. The majority of theme differences are toggled via `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/CSS/Using_CSS_custom_properties"
      }}>{`CSS custom properties`}</a>{`, which keeps theme code lean and selector conflicts minimal. Themes may be nested in other themes.`}</p>
    <h2>{`Light`}</h2>
    <p>{`The default theme, applied to the document `}<inlineCode parentName="p">{`:root`}</inlineCode>{` by default.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Light" parameters={{
        theme: 't-light'
      }} args={{
        theme: 'light'
      }} mdxType="Story">
    {demoStory.bind({})}
  </Story>
    </Canvas>
    <h2>{`Dark`}</h2>
    <p>{`Optimized for page intros and headings.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Dark" parameters={{
        theme: 't-dark'
      }} args={{
        theme: 'dark'
      }} mdxType="Story">
    {demoStory.bind({})}
  </Story>
    </Canvas>
    <h2>{`Alternate`}</h2>
    <p>{`An alternate, or secondary, theme that can offset a section of content visually from its surroundings. This may be helpful for distinguishing rows of content from one another in a subtle way.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Alternate with Light" parameters={{
        theme: 't-light'
      }} args={{
        theme: 'light'
      }} mdxType="Story">
    {args => alternateDemo(args)}
  </Story>
    </Canvas>
    <Canvas mdxType="Canvas">
  <Story name="Alternate with Dark" parameters={{
        theme: 't-dark'
      }} args={{
        theme: 'dark'
      }} mdxType="Story">
    {args => alternateDemo(args)}
  </Story>
    </Canvas>
    <h2>{`Coming soon`}</h2>
    <ul>
      <li parentName="ul">{`Better progressive enhancement (sensible default values for older browsers)`}</li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const light = demoStory.bind({});
light.storyName = 'Light';
light.args = {
  theme: 'light'
};
light.parameters = { storySource: { source: 'demoStory.bind({})' }, ...{
  theme: 't-light'
} };

export const dark = demoStory.bind({});
dark.storyName = 'Dark';
dark.args = {
  theme: 'dark'
};
dark.parameters = { storySource: { source: 'demoStory.bind({})' }, ...{
  theme: 't-dark'
} };

export const alternateWithLight = (args => alternateDemo(args));
alternateWithLight.storyName = 'Alternate with Light';
alternateWithLight.args = {
  theme: 'light'
};
alternateWithLight.parameters = { storySource: { source: 'args => alternateDemo(args)' }, ...{
  theme: 't-light'
} };

export const alternateWithDark = (args => alternateDemo(args));
alternateWithDark.storyName = 'Alternate with Dark';
alternateWithDark.args = {
  theme: 'dark'
};
alternateWithDark.parameters = { storySource: { source: 'args => alternateDemo(args)' }, ...{
  theme: 't-dark'
} };

const componentMeta = { title: 'Design/Themes', includeStories: ["light","dark","alternateWithLight","alternateWithDark"],  };

const mdxStoryNameToKey = {"Light":"light","Dark":"dark","Alternate with Light":"alternateWithLight","Alternate with Dark":"alternateWithDark"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;